<div *ngIf="showOverlay" class="overlay"></div>
<mat-drawer-container class="mat-drawer-container--outer" [ngClass]="{ 'mat-drawer-container--closed': !isMenuOpen }">
  <mat-drawer mode="push" opened="true" disableClose="true">
    <aside class="sidebar" [ngClass]="{ 'sidebar--mini': !isMenuOpen }">
      <app-sidebar-header [currentUser]="currentUser" [(isMenuOpen)]="isMenuOpen"></app-sidebar-header>

      <div class="sidebar__menu">
        <div *ngIf="!showRoleList" [@slideInOut]="{ value: ':enter', params: { startPos: -100, endPos: -100 } }" class="sidebar-view">
          <app-sidebar-user-info [currentUser]="currentUser" (click)="openRoleList(true)" class="mb-4"></app-sidebar-user-info>
          <nav class="sidebar__navigation">
            <ul class="sidebar__navigation-list">
              <app-sidebar-menu-item
                *ngFor="let menuItem of menuItems; trackBy: trackById"
                [menuItem]="menuItem"
                [serviceRequestQueue]="serviceRequestQueue"
                [serviceRequestDynamicData]="serviceRequestDynamicData"
                [(isMenuOpen)]="isMenuOpen"
              ></app-sidebar-menu-item>
            </ul>
          </nav>
          <app-sidebar-actions [isCustomerRole]="isCustomerRole" (signOutClicked)="signOutClicked.emit()"></app-sidebar-actions>
        </div>
        <div *ngIf="showRoleList" [@slideInOut]="{ value: ':enter', params: { startPos: 100, endPos: 100 } }" class="sidebar-view">
          <app-sidebar-switch-role [currentUser]="currentUser" (backClicked)="openRoleList(false)"></app-sidebar-switch-role>
        </div>
      </div>
    </aside>
  </mat-drawer>

  <mat-drawer-content>
    <app-header (signOutClicked)="signOutClicked.emit()" [(isMenuOpen)]="isMenuOpen" (isUserMenuChange)="checkOpenMenu($event)"></app-header>

    <div class="sidebar-content">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
